module.exports = __webpack_public_path__ + "static/media/3.ffa52976.jpg";